<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="epigraph">
<blockquote class="blockquote1">
<p class="epi"><span aria-label="vi" epub:type="pagebreak" id="page_vi" role="doc-pagebreak" title="vi"><span aria-label="vii" epub:type="pagebreak" id="page_vii" role="doc-pagebreak" title="vii">They wanna try and keep everything hushed up. Like it’s some kind of big secret.… They won’t tell us what it is. They don’t wanna talk to me. Because I’m an old dumb farmer, I’m not supposed to know anything. But it’s not gonna be covered up. Because I’m gonna bring it out in the open for people to see.</span></span></p>
<p class="epi-att">—Wilbur Earl Tennant</p>
</blockquote>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4e0fa8d8